import { Box } from '@mui/material';
import { Chart, ChartOption } from '@/components/Base/Chart';

interface Props {
  data: { bimestre: string; media: number }[];
}

const LineChartEvolucao: React.FC<Props> = ({ data }) => {
  const bimestres = data.map((d) => d.bimestre);
  const valores = data.map((d) => d.media);

  const option: ChartOption = {
    title: {
      text: 'Evolução por Bimestre',
      textStyle: { fontSize: 14 },
    },
    tooltip: {
      trigger: 'axis',
      axisPointer: { type: 'cross', label: { backgroundColor: '#6a7985' } },
    },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: {
      type: 'category',
      boundaryGap: false,
      data: bimestres,
    },
    yAxis: {
      type: 'value',
      min: 0,
      max: 10,
    },
    series: [
      {
        name: 'Média',
        type: 'line',
        smooth: true,
        symbol: 'circle',
        symbolSize: 14,
        lineStyle: { color: '#1c9c7c', width: 4 },
        itemStyle: { color: '#1c9c7c' },
        label: {
          show: true,
          position: 'top',
          fontWeight: 'bold',
          formatter: '{c}',
        },
        areaStyle: { color: 'rgba(28, 156, 124, 0.15)' },
        emphasis: { focus: 'series' },
        data: valores,
      },
    ],
  };

  return (
    <Box
      sx={{
        background: '#fff',
        borderRadius: '14px',
        border: '1px solid rgba(176, 176, 176, 1)',
        p: '20px',
      }}
      height="400px"
    >
      <Chart option={option} />
    </Box>
  );
};

export default LineChartEvolucao;
